'use client';

import { c as _c } from "react/compiler-runtime";
import { type Context, createContext, type ReactNode, useContext } from 'react';
import type { Network } from './types';
interface NetworkPresentation {
  readonly network: Network;
  readonly publicSiteOrigin: string;
}
const NetworkPresentationContext: Context<NetworkPresentation | null> = createContext<NetworkPresentation | null>(null);

/** Shared presentation follows the SDK host's network without changing public-app preferences. */
export function NetworkPresentationProvider(t0) {
  const $ = _c(6);
  const {
    network,
    publicSiteOrigin,
    children
  } = t0;
  const parsed = new URL(publicSiteOrigin);
  if (!["http:", "https:"].includes(parsed.protocol) || parsed.origin !== publicSiteOrigin) {
    throw new Error("The public market site must be an HTTP(S) origin.");
  }
  let t1;
  if ($[0] !== network || $[1] !== publicSiteOrigin) {
    t1 = {
      network,
      publicSiteOrigin
    };
    $[0] = network;
    $[1] = publicSiteOrigin;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== children || $[4] !== t1) {
    t2 = <NetworkPresentationContext.Provider value={t1}>{children}</NetworkPresentationContext.Provider>;
    $[3] = children;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
export function useNetworkPresentation() {
  return useContext(NetworkPresentationContext);
}